import { ArcDimension } from "@/Dimensions/ArcDimension";
import { LineDimension } from "@/Dimensions/LineDimension";
import { AnchorPointAux } from "@/Dimensions/AnchorPointAuxs";
import { BPLinear } from "@/core/BPLinear";
import { OrthogonalAux } from "@/Dimensions/OrthogonalAux";
import { CircleAnchorPointAuxs } from "@/Dimensions/CircleAnchorPointAuxs";
import {
  DBEntity,
  DbLayer,
  DbLine,
  DrawManager,
  FMathUtils,
  ModelManager,
  ViewManager,
} from "@/CadEngine";
export class DimensionGroup {
  private m_dimension: LineDimension;
  private m_arcDimension: ArcDimension;
  private m_anchor: AnchorPointAux; // 十字mesh
  private m_orthogonalAux: OrthogonalAux;
  private m_circleAnchor: CircleAnchorPointAuxs;
  constructor(view: ViewManager, root: THREE.Object3D) {
    this.m_arcDimension = new ArcDimension(view, root);
    this.m_dimension = new LineDimension(view, root);
    this.m_anchor = new AnchorPointAux(view, root);
    this.m_orthogonalAux = new OrthogonalAux(view, root);
    this.m_circleAnchor = new CircleAnchorPointAuxs(view, root);
  }

  public get Line() {
    return this.m_dimension;
  }

  public get Arc() {
    return this.m_arcDimension;
  }
  public get Anchor() {
    return this.m_anchor;
  }

  public get OrthogonalAux() {
    return this.m_orthogonalAux;
  }

  public get CircleAnchor() {
    return this.m_circleAnchor;
  }

  public dispose() {
    if (this.Arc) this.Arc.dispose();
    if (this.Line) this.Line.dispose();
    if (this.m_anchor) this.m_anchor.dispose();
    if (this.m_orthogonalAux) {
      this.m_orthogonalAux.dispose();
    }
    if (this.m_circleAnchor) this.m_circleAnchor.dispose();
  }
}
